import { ERROR_RETRIEVING_SCAN_STATUS_DATA, NO_RESULTS_SCAN_STATUS_DATA, RECEIVE_SCAN_STATUS_DATA, REQUEST_SCAN_STATUS_DATA } from "../actions/scanStatusDataActions";

const initialState = {
    scanStatuses: [],
    noResults: false,
    isFetching: false
};

export default function (state = initialState, action) {

    switch (action.type) {

        case REQUEST_SCAN_STATUS_DATA:
            return {
                ...state,
                isFetching: true
            };
        case RECEIVE_SCAN_STATUS_DATA:
            return {
                ...state,
                scanStatuses: action.payload.scanStatuses,
                isFetching: false
            };
        case NO_RESULTS_SCAN_STATUS_DATA:
            return {
                ...state,
                noResults: true,
                isFetching: false
            };
        case ERROR_RETRIEVING_SCAN_STATUS_DATA:
            return {
                ...initialState,
                error: action.payload,
                isFetching: false
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/scanStatusReducer.js